<template>

  <main class="Page-styles-page Page-styles-desktop">
    <div class="bg" style="display: none">
      <div class="formm">
        <div class="card card-container">
          <div class="form-signin">
            <div class="row error" v-if="loginError">
              Kullanıcı adı yada şifre yanlış
            </div>
            <form v-on:submit.prevent="login">
              <p class="input_title pt">{{ t.user.username }}</p>
              <input type="text" class="login_box" v-model="username" name="username" required="">
              <p class="input_title">{{ t.user.password }}</p>
              <input type="password" class="login_box" v-model="password" name="password" required="">
              <button class="btn btn-lg btn-primary btn-signin" type="submit">Giriş</button>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="AccountWrapperContainer-styles-outer-container AccountWrapperContainer-styles-outer-container-tipico-desktop">
      <div class="Paper-styles-paper AccountWrapperContainer-styles-paper">
        <div class="AccountWrapperContainer-styles-column-left">
          <div class="AccountWrapperContainer-styles-image-container">
            <picture>
              <img src="/static/assets/img/left_column_banner_default.jpg" alt="account-banner" height="563" width="432"></picture>
            <div class="SimpleBannerContent-styles-banner">
              <div class="SimpleBannerContent-styles-text">{{ t.login_slogan }}</div>
            </div>
          </div>
        </div>
        <div class="AccountWrapperContainer-styles-column-right">
          <div class="Login-styles-login-wrapper Login-styles-desktop">
            <div class="LoginForm-styles-login">
              <div class="LoginFormHeader-styles-login-form-header-desktop LoginFormHeader-styles-login-form-header-desktop-tipico-desktop">
                <h2 class="LoginFormHeader-styles-title">{{ t.welcome }}</h2></div>
              <div class="LoginForm-styles-desktop-register-cta">
                <div class="LoginForm-styles-account-informations LoginForm-styles-login-form-appendix LoginForm-styles-desktop">{{ t.dont_you_have_account }}&nbsp;<router-link :to="{name: 'Register'}" class="LoginForm-styles-login-form-appendix-link">{{ t.register_now }}</router-link></div>
              </div>
              <section class="LoginForm-styles-login-box">
                <div class="row error" v-if="loginError">
                    {{ t.auth.login_error }}
                </div>
                <form action="/" v-on:submit.prevent="login" method="GET" name="login" id="login" fields="[object Object]" errors="[object Object]" warnings="[object Object]">
                  <div class="InputGroup-styles-input-group">
                    <label class="InputGroup-styles-label" for="login-username-input">{{ t.user.username }}</label>
                    <div class="InputGroup-styles-input-wrapper">
                      <input id="login-username-input" class="FieldInput-styles-no-text" name="username" v-model="username" type="text" validate="isNotNull" spellcheck="false">
                    </div>
                    <ul class="InputMessages-styles-input-messages"></ul>
                    <ul class="InputWarnings-styles-input-messages"></ul>
                  </div>
                  <div class="InputGroup-styles-input-group FieldPassword-styles-password-input">
                    <label class="InputGroup-styles-label" for="login-password-input">{{ t.user.password }}</label>
                    <div class="InputGroup-styles-input-wrapper">
                      <div class="FieldPassword-styles-password-input-wrapper">
                        <input id="login-password-input" type="password" name="password" v-model="password" validate="isNotNull" spellcheck="false" warnings="">
                        <div class="VisibilitySwitch-styles-visibilitySwitch FieldPassword-styles-visibility-switch">
                          <button type="button" id="login-password-input-password-visibility" class="VisibilitySwitch-styles-visibilitySwitchButton"></button><span class="VisibilitySwitch-styles-visibilitySwitchButtonLabel">Göstermek</span></div>
                      </div>
                    </div>
                    <ul class="InputMessages-styles-input-messages"></ul>
                    <ul class="InputWarnings-styles-input-messages"></ul>
                  </div>
                  <div class="FieldCheckbox-style-checkbox">
                    <label class="FieldCheckbox-style-wrapper">
                      <input class="FieldCheckbox-style-input" id="login-stayLoggedIn-input" name="stayLoggedIn" type="checkbox" warnings="" value=""><span class="FieldCheckbox-style-indicator"></span>
                      <div class="FieldCheckbox-style-label">{{ t.remember_me }}</div>
                    </label>
                  </div>
                  <div class="LoginForm-styles-hidden-input">
                    <div class="InputGroup-styles-input-group">
                      <div class="InputGroup-styles-input-wrapper">
                        <input id="login-clientType-input" class="FieldInput-styles-no-text" name="clientType" type="hidden" value="DESKTOP_WEB_RETH">
                      </div>
                      <ul class="InputMessages-styles-input-messages"></ul>
                      <ul class="InputWarnings-styles-input-messages"></ul>
                    </div>
                  </div>
                  <button id="login-submit-button" class="Button-styles-button Button-styles-primary Button-styles-general LoginForm-styles-submit-button" type="submit">
                    <div class="">{{ t.login }}</div>
                  </button>
                  <span class="LoginForm-styles-account-informations">
                    <router-link :to="{name: 'Password'}" href="javascript:;">{{ t.forgot_password }}</router-link>
                  </span>
                  <div id="recaptcha" class="LoginForm-styles-recaptcha">
                    <div class="grecaptcha-badge" data-style="bottomright" style="width: 256px; height: 60px; display: block; transition: right 0.3s ease 0s; position: fixed; bottom: 14px; right: -186px; box-shadow: gray 0px 0px 5px; border-radius: 2px; overflow: hidden;">
                      <div class="grecaptcha-logo">
                        <iframe title="reCAPTCHA" src="https://www.google.com/recaptcha/api2/anchor?ar=1&amp;k=6LcxhLkUAAAAAFl2yxNWSRW8hmhHJC6yInYLEWen&amp;co=aHR0cHM6Ly9hY2NvdW50LnRpcGljby5kZTo0NDM.&amp;hl=tr&amp;v=BycHQdSIhzR_1EcOLw2mOzYQ&amp;size=invisible&amp;badge=bottomright&amp;cb=k9iyhaw867dp" width="256" height="60" role="presentation" name="a-dznuliz6dj67" frameborder="0" scrolling="no" sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-top-navigation allow-modals allow-popups-to-escape-sandbox"></iframe>
                      </div>
                      <div class="grecaptcha-error"></div>
                      <textarea id="g-recaptcha-response" name="g-recaptcha-response" class="g-recaptcha-response" style="width: 250px; height: 40px; border: 1px solid rgb(193, 193, 193); margin: 10px 25px; padding: 0px; resize: none; display: none;"></textarea>
                    </div>
                    <iframe style="display: none;"></iframe>
                  </div><span style="display: none;" class="LoginForm-styles-account-informations LoginForm-styles-customer-card">Müşteri kartınız var mı? &nbsp;<a href="javascript:;">
 Kartımı etkinleştir</a></span></form>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'LoginTop',
  data() {
    return {
      t: this.$root.t,
      username: null,
      password: null,
      loginError: false,
      blurred: true,
      session: session
    }
  },
  mounted() {
    this.isLogged();
  },
  methods: {
    isLogged() {

      var th = this;
      this.$getItem('auth', function (key, value) {

        th.$http.get(api + 'oauth/v2/token',
            {
              params: {
                client_id: value.client, client_secret: value.clientSecret, grant_type: 'refresh_token',
                refresh_token: value.refreshToken
              }
            }).then(
            response => {

              window.accessTokenHeader = response.body.access_token;
              window.auth.accessToken = response.body.access_token;
              window.auth.refreshToken = response.body.refresh_token;
              window.auth.client = value.client;
              window.auth.clientSecret = value.clientSecret;

              th.$setItem('auth', window.auth);


            }, response => {
              th.blurred = false;
            });

      }, function (err) {

      })
    },
    login() {
      if (this.password && this.username) {
        this.loginError = false;
        this.blurred = true;
        this.$bus.$emit('globalLoader', false);

        if (typeof window.auth.client === 'undefined')
          this.$parent.getClient();

        this.clientId = window.auth.client;
        this.clientSecret = window.auth.clientSecret;

        this.$bus.$emit('globalLoader', true);

        this.$http.get(api + 'oauth/v2/token',
            {
              params: {
                client_id: this.clientId, client_secret: this.clientSecret, grant_type: 'password',
                username: this.username, password: this.password
              }
            }).then(
            response => {
              this.$emit('accessToken', {
                at: response.body.access_token,
                rt: response.body.refresh_token
              });
              window.accessTokenHeader = response.body.access_token;

              window.auth.accessToken = response.body.access_token;
              window.auth.refreshToken = response.body.refresh_token;

              this.$setItem('auth', window.auth);
              this.blurred = false;

              setTimeout(() => {
                this.$bus.$emit('accessToken', true);
                this.$router.push({name: 'Home'})
                this.$bus.$emit('globalLoader', false);
              }, 500)


            }, response => {
              this.$bus.$emit('globalLoader', false);
              this.loginError = true;
              this.blurred = false;

              this.$notify({
                group: 'app',
                title: this.t.processing.error,
                text: this.t.auth.login_error,
                type: 'error',
              });

            });
        return false;
      }else {
        this.loginError = true;
      }
    },
    forgotPassword() {
      this.$refs.fpmodal.open()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.error {
  color: red;
  padding: 10px;
}

.formm {
  width: 320px;
  padding-top: 5vh;
  margin: auto;
}

.bg {
  font-family: 'Source Sans Pro', sans-serif;
  width: 100%;
  height: 100%;
  background: url(/static/assets/img/login-bg.jpg);
  background-size: cover;
  overflow: hidden;
  font-size: .875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #576472;
  text-align: left;
  position: fixed;
  top: 0;
  left: 0;
}
.card {
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border-radius: 2px;
  background-color: #fff;
  padding: 1px 25px 30px;
  margin: 20% auto 25px;
  border-radius: 2px;
  box-shadow: 0 2px 2px rgb(0 0 0 / 30%);
  border: 1px solid #e8ecf1;
  position: relative;
}
.input_title.pt {
  padding-top: 15px;
}
.input_title {
  color: rgba(0,0,0,.5);
  padding-left: 5px;
  margin: 10px 0;
  font-size: 13px;
}

.form-signin input {
  width: 100%;
  display: block;
  z-index: 1;
  position: relative;
  box-sizing: border-box;
}

.login_box {
  background: #f7f7f7;
  border: 1px solid rgba(0,0,0,.2);
  margin-bottom: 25px;
  padding: 8px 5px;
}
.btn.btn-signin {
  background-color: #3c3c3c;
  padding: 0;
  font-weight: 700;
  font-size: 14px;
  height: 45px;
  border-radius: 0;
  border: none;
  transition: all 218ms;
  text-transform: uppercase;
}
.form-signin button {
  width: 100%;
  display: block;
  z-index: 1;
  position: relative;
  box-sizing: border-box;
}

.AccountWrapperContainer-styles-outer-container{padding-top:100px;padding-bottom:20px;width:900px;margin:0 auto}.AccountWrapperContainer-styles-outer-container .AccountWrapperContainer-styles-paper{display:flex}.AccountWrapperContainer-styles-outer-container-games .AccountWrapperContainer-styles-image-container:not(.AccountWrapperContainer-styles-no-gradient):after,.AccountWrapperContainer-styles-outer-container-mysino-account .AccountWrapperContainer-styles-image-container:not(.AccountWrapperContainer-styles-no-gradient):after,.AccountWrapperContainer-styles-outer-container-mysino-games .AccountWrapperContainer-styles-image-container:not(.AccountWrapperContainer-styles-no-gradient):after,.AccountWrapperContainer-styles-outer-container-mysino-payment .AccountWrapperContainer-styles-image-container:not(.AccountWrapperContainer-styles-no-gradient):after{background-image:-o-linear-gradient(bottom,var(--firefly),transparent);background-image:linear-gradient(0deg,var(--firefly),transparent)}.AccountWrapperContainer-styles-outer-container-games .AccountWrapperContainer-styles-column-left,.AccountWrapperContainer-styles-outer-container-mysino-account .AccountWrapperContainer-styles-column-left,.AccountWrapperContainer-styles-outer-container-mysino-games .AccountWrapperContainer-styles-column-left,.AccountWrapperContainer-styles-outer-container-mysino-payment .AccountWrapperContainer-styles-column-left{background:var(--firefly)}.AccountWrapperContainer-styles-column-left{flex:0 0 432px;background:var(--black-box-shadow);min-height:750px}.AccountWrapperContainer-styles-column-left img{width:100%}.AccountWrapperContainer-styles-column-right{flex:1;padding:34px 48px}.AccountWrapperContainer-styles-column-right h1{font-size:26px;padding:0 24px;margin-top:14px;margin-bottom:6px}.AccountWrapperContainer-styles-image-container{width:100%;position:relative}.AccountWrapperContainer-styles-image-container:not(.AccountWrapperContainer-styles-no-gradient):after{content:" ";position:absolute;width:100%;height:30%;bottom:0;left:0;background-image:-o-linear-gradient(bottom,var(--black-box-shadow),transparent);background-image:linear-gradient(0deg,var(--black-box-shadow),transparent)}.SimpleBannerContent-styles-banner{margin:-150px 32px 0}.SimpleBannerContent-styles-banner .SimpleBannerContent-styles-text{font-size:40px;line-height:48px;color:var(--white);padding:0 48px;transform:translateY(50%);font-weight:600;font-style:normal;position:absolute;width:100%;bottom:0;left:0;z-index:2}.Login-styles-login-wrapper{display:flex;flex-direction:column;justify-content:space-between;width:100%;height:100vh;padding:8px 16px;margin:auto}@media only screen and (min-width:768px){.Login-styles-login-wrapper{max-width:768px}}.Login-styles-login-wrapper.Login-styles-desktop{height:inherit;padding-top:38px}.Login-styles-login-wrapper.Login-styles-desktop h2{font-size:26px}.Login-styles-login-header{display:flex;position:relative;margin-top:env(safe-area-inset-top,24px)}.Login-styles-login-header>div{flex:1}.Login-styles-login-header>div:first-child{text-align:left;align-content:start}.Login-styles-login-header>div:nth-child(2){text-align:right;align-content:end}.Login-styles-login-header-image>img{position:relative;top:4px;left:4px}.Login-styles-login-header-image-bundesliga6>img{display:none}.Login-styles-close-button{display:block;width:20px;height:20px;position:absolute;top:8px;right:8px;overflow:hidden;cursor:pointer}.Login-styles-close-button:hover:after,.Login-styles-close-button:hover:before{background:var(--blue)}.Login-styles-close-button:after,.Login-styles-close-button:before{content:"";position:absolute;height:2px;width:100%;top:50%;left:0;margin-top:-1px;background:var(--grey)}.Login-styles-close-button:before{-webkit-transform:rotate(45deg);transform:rotate(45deg)}.Login-styles-close-button:after{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}.Login-styles-close-button.Login-styles-close-button-bundesliga6.Login-styles-native-ios{margin-top:24px}@media only screen and (device-width:375px) and (device-height:812px) and (-webkit-device-pixel-ratio:3),only screen and (device-width:414px) and (device-height:896px) and (-webkit-device-pixel-ratio:2),only screen and (device-width:414px) and (device-height:896px) and (-webkit-device-pixel-ratio:3){.Login-styles-close-button.Login-styles-close-button-bundesliga6.Login-styles-native-ios{margin-top:44px}}.Login-styles-close-button.Login-styles-close-button-bundesliga6.Login-styles-native-android{margin-top:24px}.LoginForm-styles-login{display:flex;flex-direction:column;flex:1 0 auto;width:100%;justify-content:center}.LoginForm-styles-login .LoginForm-styles-login-box>form{display:flex;flex:1;flex-direction:column}.LoginForm-styles-login .LoginForm-styles-biometric-login{display:flex;flex-direction:column}.LoginForm-styles-login .LoginForm-styles-biometric-login .LoginForm-styles-mobile-buttons{margin:16px 0}.LoginForm-styles-login .LoginForm-styles-account-informations{padding-top:15px;display:block;text-align:center;font-size:15px}.LoginForm-styles-login .LoginForm-styles-account-informations a{color:var(--blue-steel);text-decoration:none}.LoginForm-styles-login .LoginForm-styles-customer-card{margin-top:64px}.LoginForm-styles-login .LoginForm-styles-login-form-appendix{padding-bottom:24px}.LoginForm-styles-login .LoginForm-styles-login-form-appendix-link{font-weight:600}.LoginForm-styles-message-margin{margin:0}.LoginForm-styles-message-transparent,.LoginForm-styles-messages-transparent div{background:none;color:var(--red);align-items:center;padding:0}.LoginForm-styles-message-transparent{padding-bottom:8px}.LoginForm-styles-recaptcha{display:flex;justify-content:center;margin-top:24px}.LoginForm-styles-submit-button{margin:24px 0}.LoginForm-styles-warning-message{color:var(--black)}.LoginForm-styles-hidden-input{display:none}.LoginForm-styles-desktop-register-cta .LoginForm-styles-login-form-appendix.LoginForm-styles-desktop{text-align:left}.LoginForm-styles-desktop-register-cta .LoginForm-styles-login-form-appendix-link{font-weight:inherit}.LoginForm-styles-sh-link-here{color:var(--blue-steel);font-weight:600;text-decoration:underline;cursor:pointer}.MobileButton-styles-mobile-button{position:relative;display:flex;flex-direction:column;justify-content:center;align-items:center;height:64px;border-radius:4px;border:1px solid var(--blue);background-color:var(--white);padding-left:44px;margin-bottom:16px}.MobileButton-styles-mobile-button .MobileButton-styles-icon{position:absolute;width:32px;height:32px;top:16px;left:12px}.MobileButton-styles-mobile-button .MobileButton-styles-primary-text{font-size:17px;color:var(--blue);font-weight:600;margin-bottom:4px}.MobileButton-styles-mobile-button .MobileButton-styles-secondary-text{font-size:13px;color:var(--grey-light)}.app-container,body,html{min-height:100%}.LoginFormHeader-styles-login-form-header-desktop .LoginFormHeader-styles-title{margin:0;font-size:22px;font-weight:600;color:var(--black);line-height:1.18}.LoginFormHeader-styles-login-form-header{display:flex;flex-direction:column;align-items:center}.LoginFormHeader-styles-login-form-header.LoginFormHeader-styles-desktop{margin-bottom:32px}.LoginFormHeader-styles-login-form-header .LoginFormHeader-styles-title{margin:0;font-size:22px;font-weight:600;color:var(--black);line-height:1.18}.LoginFormHeader-styles-login-form-header .LoginFormHeader-styles-logo{height:32px}.LoginFormHeader-styles-login-form-header .LoginFormHeader-styles-text{font-size:15px;line-height:1.4;font-weight:400;color:var(--grey-dark);text-align:center;padding-top:8px}
/*# sourceMappingURL=16.c3b26028c84de52ebf9b.css.map*/
</style>



// WEBPACK FOOTER //
// src/components/auth/login.vue